<form id="reactive" [formGroup]="formGroup">
    <div mat-dialog-content>
        <p>Please enter folder name</p>

        <div class="message-content">
            <mat-form-field class="full-width">
                <mat-label>Folder Name</mat-label>
                <input matInput type="text" [formControl]="folderFormControl" (change)="folderChanged()">
            </mat-form-field>
        </div>

    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onCancelClick()">CANCEL</button>
        <button mat-button [mat-dialog-close]="data" [disabled]="formGroup.invalid">OK</button>
    </div>
</form>